<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-briefcase"></i> Fase</h3>
      </div>
    </div>
    <FaseAdd v-if="showAdd" ref="FaseAdd" v-on:Back="onBack" />
    <FaseList v-else ref="FaseList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import FaseAdd from './components/add/faseadd.vue'
import FaseList from './components/list/faselist.vue'

export default {
  name: 'Fase',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    FaseAdd,
    FaseList
  },
  mounted () { },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.FaseAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/ajuizamento/fase/fase.vue